'use client';

import { useToast } from '@common/hooks';
import { useEffect } from 'react';

export const WelloPointOnlyEntryToast = () => {
  const { toast } = useToast();

  useEffect(() => {
    toast({
      type: 'info',
      message: '이 상품은 웰포인트로만 구매가 가능해요!',
    });
  }, [toast]);

  return null;
};
